export default __webpack_public_path__ + "static/media/icon-insights-google.db1a4fed.svg";